<ng-container *ngIf="product$ | async as product">
  <div *ngIf="product.stock?.stockLevelStatus !== 'outOfStock' && product.maxDeliveryDays"
       class="text-center text-md-right mt-3">
    <span class="delivery-time-description">
      {{ 'productDetails.estimatedDeliveryTime' | cxTranslate: {days: product.maxDeliveryDays} }}
    </span>
  </div>
</ng-container>
